import React, { useEffect, useState } from 'react';
import './AdminChats.css';
import { API_URL } from '../../environment';

interface DashboardRow {
  data: string;
  disparos: number;
  interacoes: number[]; // 0 a 6 => 1a a +6
  sim: number;
  nao: number;
  email: number;
}

interface Props {
  clientes: { id: number; cliente: string }[];
  startDate: string;
  endDate: string;
  onStartDateChange: (v: string) => void;
  onEndDateChange: (v: string) => void;
}

export default function DashboardTable({ clientes, startDate, endDate, onStartDateChange, onEndDateChange }: Props) {
  const [rows, setRows] = useState<DashboardRow[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!clientes.length) return;

    setLoading(true);
    const params = new URLSearchParams();
    clientes.forEach((c, i) => {
      if (c && typeof c.id === 'number') {
        params.append('id_sdr', c.id.toString());
      } else {
        console.warn(`⚠️ Cliente inválido na posição ${i}:`, c);
      }
    });

    if (startDate) params.append('start', startDate);
    if (endDate) params.append('end', endDate);

    console.log('clientes recebidos:', clientes);

    fetch(`${API_URL}/admin/dashboard_sdr?${params.toString()}`)
      .then(res => res.json())
      .then(data => setRows(data))
      .catch(err => console.error('Erro ao carregar dashboard:', err))
      .finally(() => setLoading(false));
  }, [clientes, startDate, endDate]);

  return (
    <div className="dashboard-wrapper">
      <div className="date-filter">
        <label>De: </label>
        <input type="date" value={startDate} onChange={e => onStartDateChange(e.target.value)} />
        <label>Até: </label>
        <input type="date" value={endDate} onChange={e => onEndDateChange(e.target.value)} />
      </div>

      {loading ? (
        <p>Carregando...</p>
      ) : rows.length === 0 ? (
        <p>Nenhum dado encontrado para os números selecionados.</p>
      ) : (
        <table className="dashboard-table">
          <thead>
            <tr>
              <th>Data</th>
              <th>Disparos</th>
              <th>1ª Interação</th>
              <th>2ª Interação</th>
              <th>3ª Interação</th>
              <th>4ª Interação</th>
              <th>5ª Interação</th>
              <th>6ª Interação</th>
              <th>+6 Interações</th>
              <th>Sim</th>
              <th>Não</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => {
              const total = row.disparos || 1; // evita divisão por zero

              const format = (valor: number) =>
                `${valor} (${((valor / total) * 100).toFixed(0)}%)`;

              return (
                <tr key={idx}>
                  <td>{row.data}</td>
                  <td>{row.disparos}</td>
                  {row.interacoes.map((count, i) => (
                    <td key={i}>{format(count)}</td>
                  ))}
                  <td>{format(row.sim)}</td>
                  <td>{format(row.nao)}</td>
                  <td>{format(row.email || 0)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
